import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC0_MfrITSLF9uIM-xBtoF0P3TCITQjdFU",
  authDomain: "community-teaching-sk.firebaseapp.com",
  projectId: "community-teaching-sk",
  storageBucket: "community-teaching-sk.appspot.com",
  messagingSenderId: "542077536128",
  appId: "1:542077536128:web:7ba1c4410737e00deee365",
  measurementId: "G-FQDTDZ1Y96",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();

const db = firebaseApp.firestore();

export { auth, provider };

export default db;
